'use strict';

require('../../helpers/rawFilter/rawFilter');
require('../../modules/ui/ui');
require('../../modules/maps/maps');

angular.module('far.core', [
        'ngCookies',
        'ngAnimate',
        'duScroll',
        'mgcrea.bootstrap.affix',
        'far.helpers.rawFilter',
        'far.ui',
        'far.maps'
    ])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
    }])
    .value('duScrollOffset', 85)
    .value('duScrollActiveClass', 'page-menu__item')
    .run(function () {
        var jqLite = angular.element;

        jqLite.prototype.has = function (element) {
            var children = this.children(), i;

            for (i = 0; i < children.length; i++) {
                if (children[i] == element) {
                    return true;
                }
            }

            for (i = 0; i < children; i++) {
                var subChildren = jqLite(children[i]).children();
                if (subChildren.length > 0) {
                    for (var ii = 0; ii < subChildren.length; ii++) {
                        if (jqLite(subChildren[ii]).has(element)) {
                            return true;
                        }
                    }

                }
            }

            return false;
        };
    })